export default __webpack_public_path__ + "static/media/polaroid_temp.7bd5dbe5.png";